import React from "react";
import { JobEntityType } from "../../../../lib/supabase/supabaseTypes";
import { useNavigate } from "react-router-dom";
import { JobSelectionWithSearchComponent } from "../../components/Dialog/job-selection-with-search.component";

export const JobsPage = () => {
	const navigate = useNavigate();
	return (
		<div className="w-full h-full">
			<div className="font-bold text-xl mb-4">Aufträge</div>
			<JobsComponent onSelect={(jobId) => navigate(`/job/${jobId}`)} />
		</div>
	);
};

export const JobsComponent = ({
	onSelect,
}: {
	onSelect: (jobId: string) => void;
}) => {
	return (
		<JobSelectionWithSearchComponent
			handleSelect={onSelect}
		/>
	);
};
